export const iconFontAwesomeCampingMattressPillow = (
	<i className="fa-solid fa-mattress-pillow"></i>
);
